import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFileLines,
    faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import { TaskStatusResponse } from 'queries/InvestmentMemo/useTaskStatus';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import useMarkInvestmentMemoViewed from 'queries/InvestmentMemo/useMarkInvestmentMemoViewed';
import { LatestInvestmentMemoResponse } from 'queries/InvestmentMemo/useLatestInvestmentMemo';

interface TaskStatusDisplayProps {
    organizationId: string;
    dealId: number;
    proFormaId: number;
    latestInvestmentMemo?: LatestInvestmentMemoResponse;
    taskStatus: TaskStatusResponse;
}

const TaskStatusDisplay = ({
    organizationId,
    dealId,
    proFormaId,
    latestInvestmentMemo,
    taskStatus,
}: TaskStatusDisplayProps) => {
    const { status } = taskStatus;

    const { mutate: markInvestmentMemoViewed } = useMarkInvestmentMemoViewed({
        organizationId,
        dealId,
        proFormaId,
        investmentMemoId: latestInvestmentMemo?.id ?? 0,
    });

    if (status === 'PENDING' || status === 'PROGRESS') {
        return (
            <div className="d-flex align-items-center justify-content-center mt-2">
                <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />
                Generating deck...
            </div>
        );
    }

    if (status === 'SUCCESS' && latestInvestmentMemo?.documentId && !latestInvestmentMemo.viewedAt) {
        return (
            <div className="mt-2">
                <a
                    href={`/deal/${dealId}/documents`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm d-flex text-success align-items-center justify-content-center w-100"
                    onClick={() => {
                        if (latestInvestmentMemo?.id) {
                            markInvestmentMemoViewed();
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faFileLines} className="mr-2" />
                    View deck in Documents
                </a>
            </div>
        );
    }

    if (status === 'FAILURE') {
        return (
            <div className="d-flex align-items-center justify-content-center mt-2">
                <FontAwesomeIcon icon={faTriangleExclamation} className="text-danger mr-2" />
                Error generating deck, please try again
            </div>
        );
    }

    return null;
};

export default TaskStatusDisplay;
